<template>
  <v-card class="mt-3 mb-0 mx-5" style="height: 85vh; max-height: 85vh">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        QuickPlant
        {{
          disegno_sel.des_disegno != "" ? `- ${disegno_sel.des_disegno}` : ""
        }}</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="aggiungiDisegno"
            color="blue-grey lighten-5"
            small
            v-show="tabella_disegni_visible === true"
            v-on="on"
            v-bind="attrs"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Disegno</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="apriTabellaModuli"
            color="blue-grey lighten-5"
            small
            v-show="tabella_disegni_visible === true"
            v-on="on"
            v-bind="attrs"
          >
            <v-icon color="primary">mdi-table</v-icon>
          </v-btn>
        </template>
        <span>Configurazione Moduli Esterni</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="disegno_sel.des_disegno === ''"
            @click="esci"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </template>
        <span>Torna alla Home</span>
      </v-tooltip>
    </v-toolbar>

    <!-- Div contenente i filtri e la treeview -->
    <div
      style="background-color: white"
      v-if="tabella_disegni_visible === true"
    >
      <!-- Riga dei filtri -->
      <v-row align="center" class="ml-4 pt-5 mb-5" justify="start">
        <v-col cols="4" md="2">
          <v-autocomplete
            background-color="#ffffff"
            dense
            hide-details
            :items="items_disegni"
            item-text="des_disegno"
            item-value="des_disegno"
            label="Titolo"
            style="display: inline-block; max-width: 350px"
            v-model="des_disegno_search"
          >
            <template v-slot:append>
              <v-btn
                @click="des_disegno_search = ''"
                icon
                small
                v-if="des_disegno_search != ''"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="4" md="2">
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="0"
            min-width="289"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                background-color="#ffffff"
                dense
                hide-details
                label="Dalla Data (Creazione)"
                style="display: inline-block; max-width: 350px"
                v-bind:value="formatDataDa(data_da_search)"
                readonly
                v-on="on"
              >
                <template v-slot:append>
                  <v-btn @click="data_da_search = ''" icon small>
                    <v-icon color="error">mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="data_da_search"
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="4" md="2" align="start">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="getListaDisegni" small v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-magnify </v-icon>
              </v-btn>
            </template>
            <span>Cerca</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-treeview
        activatable
        :items="items_disegni.filter((e) => e.validita === 1)"
        hoverable
        item-key="id_disegno"
        :open.sync="open"
      >
        <template v-slot:prepend="{ item }">
          <!-- Bottone di modifica del disegno -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="clickModifica(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modifica Disegno</span>
          </v-tooltip>

          <!-- Bottone di modifica della configurazione del disegno -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="clickModificaConfigurazione(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-axis-arrow-info </v-icon>
              </v-btn>
            </template>
            <span>Aggiorna Configurazione</span>
          </v-tooltip>

          <!-- Spazio del titolo -->
          <span>
            <b>{{ item.des_disegno }}</b>
          </span>
        </template>

        <template v-slot:append="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="clickEliminaDisegno(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Cancella</span>
          </v-tooltip>
        </template>
      </v-treeview>
    </div>

    <Plantchart
      @chiudi_disegno="handleChiudiDisegno"
      :id_disegno="disegno_sel.id_disegno"
      :key="key_flowchart"
      v-if="plantchart_visible"
      :visible="plantchart_visible"
    >
    </Plantchart>

    <v-dialog v-model="modifica_disegno_dialog" width="75%">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"
            >Caratteristiche Disegno</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaDisegno" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiModificaDisegno"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="3">
                <v-text-field
                  autocomplete="off"
                  label="Titolo"
                  v-model="disegno_sel.des_disegno"
                >
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  autocomplete="off"
                  label="Autore"
                  v-model="disegno_sel.des_utente"
                >
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  autocomplete="off"
                  label="Data Creazione"
                  readonly
                  v-model="disegno_sel.data_ins"
                >
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  autocomplete="off"
                  label="Data Ultima Modifica"
                  readonly
                  v-model="disegno_sel.data_mod"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione -->
    <v-dialog v-model="conferma_eliminazione" persistent width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"
            >Conferma Eliminazione</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="font-size: 18px">
            Confermi di voler eliminare il diesgno
            <b>{{ disegno_sel.des_disegno }}</b> ?
          </span>

          <v-divider class="mt-4 mb-3"></v-divider>

          <div>
            <v-btn class="mr-5" @click="conferma_eliminazione = false" small>
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>

            <v-btn @click="eliminaDisegno" small>
              <v-icon color="success"> mdi-check </v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Tabella Moduli Esterni -->
    <v-dialog v-model="show_tabella_moduli" persistent width="500">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Moduli Esterni</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mr-2" @click="aggiungiModulo" small v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Modulo</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setModuli" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiModuliEsterni" small v-bind="attrs" v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-data-table :items="items_moduli" :headers="headers_moduli">
          <!-- <template v-slot:[`item.dinamico`]="{ item }">
            <v-checkbox true-value="1" false-value="0" v-model="item.dinamico" />
          </template> -->
          <template v-slot:[`item.id_modulo`]="{ item }">
            <v-autocomplete
              :items="items_moduli_select"
              item-text="cod_modulo"
              item-value="id_modulo"
              label="Modulo Esterno"
              v-model="item.id_modulo"
            >
            </v-autocomplete>
          </template>
          <template v-slot:[`item.route_configurazione`]="{ item }">
            <v-text-field label="Route" v-model="item.route_configurazione" />
          </template>
          <template v-slot:[`item.elimina`]="{ item }">
            <v-btn small @click="eliminaModulo(item)">
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- Snackbar di conferma -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import Disegno from "@/classes/Disegno.js";
import moment from "moment/moment";
import Plantchart from "../../components/PLANT/Plantchart.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "Plant",
  components: {
    Plantchart,
    SnackbarQV,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      data_da_search: moment("2021-01-01").format("YYYY-MM-DD"),
      des_disegno_search: "",
      disegno_sel: new Disegno(),
      key_flowchart: 0,

      // Modal
      conferma_eliminazione: false,
      menu1: false,
      modifica_disegno_dialog: false,
      plantchart_visible: false,
      tabella_disegni_visible: true,
      show_tabella_moduli: false,

      // Array
      headers_disegni: [
        {
          text: "Modifica",
          sortable: false,
          value: "modifica",
        },
        {
          text: "Configurazione",
          sortable: false,
          value: "configurazione",
        },
        {
          text: "Titolo",
          sortable: false,
          value: "des_disegno",
        },
        {
          text: "Utente",
          sortable: false,
          value: "des_utente",
        },
        {
          text: "Creazione",
          sortable: false,
          value: "data_ins",
        },
        {
          text: "Ultima Modifica",
          sortable: false,
          value: "data_mod",
        },
      ],
      headers_moduli: [
        {
          text: "Modulo",
          sortable: false,
          value: "id_modulo",
        },
        {
          text: "Route Configurazione",
          sortable: false,
          value: "route_configurazione",
        },
        {
          text: "Elimina",
          sortable: false,
          value: "elimina",
        },
      ],
      items_disegni: [],
      items_moduli: [],
      items_moduli_select: [],
      // items_disegni_totali: [],
      open: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    aggiungiDisegno() {
      // Apro il dialog della modifica del disegno.
      this.modifica_disegno_dialog = true;
    },
    aggiungiModulo() {
      const modulo_tmp = {
        id_modulo: -1,
        id_modulo_dinamico: -1,
        route_configurazione: "",
        validita: 1,
      };
      this.items_moduli.unshift(modulo_tmp);
    },
    apriTabellaModuli() {
      this.getModuliDinamici();
      this.getModuli();
      this.show_tabella_moduli = true;
    },
    chiudiModificaDisegno() {
      // Chiudo il dialog
      this.modifica_disegno_dialog = false;

      // Resetto le variabili di supporto del dialog
      this.disegno_sel.reset();
    },
    chiudiModuliEsterni() {
      this.show_tabella_moduli = false;
      this.items_moduli = [];
    },
    clickEliminaDisegno(arg) {
      this.disegno_sel = new Disegno(arg);
      this.conferma_eliminazione = true;
    },
    clickModifica(arg) {
      // Aumento la key per resettare il grafico, nel caso ce ne fosse bisogno.
      this.key_flowchart++;

      // Resetto i nodi attualmente aperti.
      this.open = new Array();

      // Seleziono il nodo, apro il grafico e nascondo la treewview.
      this.disegno_sel = new Disegno(arg);
      this.tabella_disegni_visible = false;
      this.plantchart_visible = true;
    },
    clickModificaConfigurazione(arg) {
      this.disegno_sel = new Disegno(arg);
      this.modifica_disegno_dialog = true;
    },
    eliminaDisegno() {
      const request = {
        controller: "Plant",
        method: "PUT",
        richiesta: {
          action: "eliminadisegno",
          token: localStorage.user_token,
          disegno: [
            {
              id_disegno: this.disegno_sel.id_disegno,
              validita: 0,
            },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Chiudo il dialog di conferma eliminazione
            this.conferma_eliminazione = false;

            // Stampo un messaggio di conferma
            this.$refs.SnackbarQV.print(
              "success",
              "Piantina eliminata con successo."
            );

            // Ricarico la lista dei disegni aggiornata.
            this.getListaDisegni();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col backend, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col backend, non è stato possibile caricare i dati."
            );
          }
        });
    },
    eliminaModulo(item) {
      if (item.id_modulo == -1) {
        item.validita = 0;

        this.items_moduli =this.items_moduli.filter((e) => e.validita != 0)
      } else {
        item.validita = 0;
        this.setModuli();
      }

    },
    esci() {
      this.$router.push("/home");
    },
    // filtra() {
    //   let items_disegni_tmp = new Array();
    //   this.items_disegni_totali.forEach((elem) => {
    //     items_disegni_tmp.push(Object.assign({}, elem));
    //   });

    //   // Filtro la des_disegno
    //   if (this.des_disegno_search != "") {
    //     // Faccio un array temporaneo
    //     let res = [];

    //     /* Filtro gli elementi visualizzati dopo i passaggi precedenti
    //      * e li inserisco in "res". */
    //     items_disegni_tmp.forEach((elem) => {
    //       if (elem.des_disegno == this.des_disegno_search) {
    //         res.push(Object.assign({}, elem));
    //       }
    //     });

    //     // Modello la risposta provvisoria su "res".
    //     items_disegni_tmp = res;
    //   }

    //   if (this.data_da_search != "") {
    //     // Faccio un array temporaneo
    //     let res = [];

    //     /* Filtro gli elementi visualizzati dopo i passaggi precedenti
    //      * e li inserisco in "res". */
    //     items_disegni_tmp.forEach((elem) => {
    //       if (elem.des_disegno == this.des_disegno_search) {
    //         res.push(Object.assign({}, elem));
    //       }
    //     });

    //     // Modello la risposta provvisoria su "res".
    //     items_disegni_tmp = res;
    //   }

    //   this.items_disegni = Array.from(items_disegni_tmp);
    // },
    formatDataDa() {
      return this.data_da_search
        ? moment(this.data_da_search).format("DD/MM/YYYY")
        : "";
    },
    getListaDisegni() {
      let request = {
        controller: "Plant",
        method: "POST",
        richiesta: {
          action: "getlistadisegni",
          token: localStorage.user_token,
          des_disegno: this.des_disegno_search,
          data_da: this.data_da_search,
        },
      };

      return this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Modifico le date.
          res.data.result.disegni.forEach((d) => {
            d.data_ins = d.data_ins
              ? moment(d.data_ins).format("DD/MM/YYYY")
              : "";
            d.data_mod = d.data_mod
              ? moment(d.data_mod).format("DD/MM/YYYY")
              : "";
          });

          // Popolo gli array dei disegni totali e dei disegni visualizzati.
          // this.items_disegni_totali = Array.from(res.data.result.disegni);
          this.items_disegni = Array.from(res.data.result.disegni);

          // Resetto i filtri nel caso fossero stati precedentemente attivati.
          this.des_disegno_search = "";

          return true;
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            `Criticità tecnica, non è stato possibile salvare i dati. Codice errore: ${res.status}.`
          );

          return false;
        }
      }).catch(e=>{
        console.error(e);
        this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server, impossibile caricare i dati.");
        return false;
      });
    },
    getModuli() {
      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getmoduli",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.items_moduli_select = [];
          this.items_moduli_select = res.data.result.moduli.filter(
            (e) => e.dinamico == 1
          );
        }
      });
    },
    getModuliDinamici() {
      let request = {
        controller: "Plant",
        method: "POST",
        richiesta: {
          action: "getmoduli",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.items_moduli = [];
          this.items_moduli = res.data;
        }
      });
    },

    handleChiudiDisegno() {
      /* Nascondo il chart, visualizzo la tabella e resetto
       * il disegno_sel per prepararmi a una nuova selezione.*/
      this.plantchart_visible = false;
      this.disegno_sel.reset();
      this.tabella_disegni_visible = true;

      // Aumento la key per resettare il componente.
      this.key_flowchart++;
    },
    // ripristina() {
    //   // Resetto i valori dei filtri
    //   this.des_disegno_search = "";

    //   // Resetto i valori della tabella
    //   this.items_disegni = new Array();
    //   this.items_disegni_totali.forEach((elem) => {
    //     this.items_disegni.push(Object.assign({}, elem));
    //   });
    // },
    salvaDisegno() {
      let request = {
        controller: "Plant",
        method: "PUT",
        richiesta: {
          action: "setdisegno",
          token: localStorage.user_token,
          disegno: [this.disegno_sel],
        },
      };

      this.$store.dispatch("api", request).then(async (res) => {
        if (res.status === 200) {
          await this.getListaDisegni();

          /* Se il salvataggio è andato a buon fine il BE mi sta
           * rispondendo con un oggetto e lo uso per entrare in modifica. */
          this.key_flowchart++;
          this.disegno_sel.id_disegno = res.data.id_disegno;
          this.tabella_disegni_visible = false;
          this.plantchart_visible = true;

          // Chiudo il dialog di creazione del nuovo nodo.
          this.modifica_disegno_dialog = false;
          this.disegno_sel.reset();
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            `Criticità tecnica, non è stato possibile salvare i dati. Codice errore: ${res.status}.`
          );
        }
      }).catch(e=>{
        console.error(e);
        this.$refs.SnackbarQV.print("error","Errore di comunicazione col server, non è stato possibile caricare i dati.");
      });
    },
    setModuli() {
            let request = {
        controller: "Plant",
        method: "PUT",
        richiesta: {
          action: "setmoduli",
          token: localStorage.user_token,
          moduli: this.items_moduli,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print(
            "success",
            `Moduli salvati con successo.`
          );
          this.getModuliDinamici();
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            `Criticità tecnica, non è stato possibile salvare i dati. Codice errore: ${res.status}.`
          );
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getListaDisegni();
  },
};
</script>
<style scoped>
</style>